module.exports = __webpack_public_path__ + "static/img/The-Precinct.3aa2ad8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/The-Precinct.jpg
// module id = XEP2
// module chunks = 0